.after-submission-form {
    padding: 16px;
    box-sizing: border-box;
}

.form-description {
    composes: form-description from '../../../core/form/fields/forms.module.css';
    font-size: var(--font-normal);
}

.form-label {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    font-size: var(--font-normal);
    line-height: 18px;
}

.form-label > input {
    margin-right: 8px;
}

.textfield {
    width: calc(100% - 21px);
    margin-left: 21px; /* aligns textfield with label above */
}

.radio-row {
    display: flex;
    align-items: center;
}
